<template>
  <div class="confirmation-summary--contacts">
    <ConfirmationSummaryRow
      v-for="agent in agents"
      :key="`agent_${agent.legacyId}`"
      label="Agent:">
      <ConfirmationSummaryContactRow :contact="agent" />
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow
      v-for="client in clients"
      :key="`client_${client.legacyId}`"
      label="Client:">
      <ConfirmationSummaryContactRow :contact="client" />
    </ConfirmationSummaryRow>
  </div>
</template>

<script>
import ConfirmationSummaryContactRow from '@/components/ConfirmationSummaryContactRow.vue';
import ConfirmationSummaryRow from '@/components/ConfirmationSummaryRow.vue';

export default {
  components: {
    ConfirmationSummaryContactRow,
    ConfirmationSummaryRow,
  },
  props: {
    agents: {
      type: Array,
      default: () => [],
    },
    clients: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
